<template>
	<div>
		<div class="modal fade" id="ChRegModal">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title" id="myModalLabel">Região</h4>
					</div>
					<div class="modal-body">
						<div class="col-sm-3">
							<span>Código</span>
							<input
								type="text"
								v-model="data.cod"
								disabled
								class="form-control"
							/>
						</div>

						<div class="col-sm-9">
							<span>Região</span>
							<input
								type="text"
								v-model="data.regiao"
								class="form-control"
							/>
						</div>
						<div class="col-sm-9">
							<span>Localidade</span>
							<input
								type="text"
								v-model="data.localidade"
								class="form-control"
							/>
						</div>
						<div class="col-sm-3">
							<span>Vencimento</span>
							<input
								type="number"
								v-model="data.vencimento"
								class="form-control"
								placeholder="Dia"
								min="1"
								max="28"
							/>
						</div>

						<div class="clearfix"></div>
						<br />
						<!-- <pre>{{data}}</pre> -->
					</div>
					<div class="modal-footer">
						<button
							type="button"
							class="btn btn-default"
							data-dismiss="modal"
						>
							<i class="fa fa-close"></i> Cancelar
						</button>
						<aBtn
							action="private-save-regions"
							@click="save"
							text="Salvar"
							icon="save"
							type="primary"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
let reset = { cod: null, regiao: '', localidade: '' };

import clone from 'js/clone';
import aBtn from 'btn';
import WBS from 'js/http';
import toastr from 'toastr';

export default {
	name: 'ChRegModal',
	components: { aBtn },
	data() {
		return {
			data: clone(reset),
		};
	},
	methods: {
		open(data = null) {
			if (data == null) this.data = clone(reset);
			else this.data = clone(data);
			$('#ChRegModal').modal('show');
		},
		save() {
			WBS.send('private-save-regions', this.data, (resp) => {
				if (resp.status == 'success') {
					$('#ChRegModal').modal('hide');
					toastr.success('Dados salvos com sucesso!');
					this.$emit('updata');
				} else {
					toastr.error(resp.msgs[0]);
					console.log(resp);
				}
			});
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/cadastros/regions/modal.vue